import { CSVVarHeaders } from './types';
import { Variable } from 'src/api/types';
import { Scope } from 'src/components/formComposed/WorkspaceVariablesForm/types';

const standardVariableNames: Record<number, string> = {
  500001: 'Annual revenue',
  500002: 'Number of staff',
  500003: 'Annual wage bill',
  500004: 'Average number of working days per year',
  500005: 'Annual cyber spend',
  500006: 'Average staff hardware cost',
  500007: 'Number of customers',
  500008: 'Average contract value',
  500009: 'Number of data records',
  500010: 'Release cycle cost',
  500011: 'Release cycle length',
  500012: 'Research and development budget',
  500013: 'Average cost to procure supplier',
  500014: 'Average invoice value',
  500015: 'Largest regular invoice value',
  500016: 'Cyber insurance limit',
  500017: 'Cyber insurance excess',
  500018: 'Cyber insurance premium',
};

export const generateCsvTemplateLink = () => {
  let csvString = Object.values(CSVVarHeaders).join(',') + '\n';

  Object.entries(standardVariableNames).forEach(([id, name]) => {
    csvString += `${name},,\n`;
  });

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  return URL.createObjectURL(blob);
};

export const getStandardVariableNames = (): string[] => {
  return Object.values(standardVariableNames);
};

const escapeCsvValue = (value: string): string => {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const sanitizeFilename = (name: string): string => {
  return name
    .replace(/[^a-zA-Z0-9-_\s]/g, '')
    .replace(/\s+/g, '_')
    .toLowerCase();
};

export const exportVariablesToCsv = (variables: Variable[], scope: Scope): void => {
  const filteredVariables =
    scope.type === 'assessment' ? variables.filter((v) => !v.workspace_variable && !v.isGlobal) : variables;

  const headers = Object.values(CSVVarHeaders).join(',');

  const rows = filteredVariables.map((variable) => {
    const name = escapeCsvValue(variable.name);
    const value = variable.value ?? '';
    const currency = variable.currency ? 'yes' : 'no';

    return `${name},${value},${currency}`;
  });

  const csvContent = [headers, ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const filename =
    scope.type === 'assessment'
      ? `${sanitizeFilename(scope.name)}_Assessment_Variables.csv`
      : 'Workspace_Variables.csv';

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
